"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledFlex = exports.StyledCard = exports.StyledColouredCard = exports.ButtonsContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const Tokens = __importStar(require("../../../styles/tokens"));
const Flex_1 = require("../../Layout/Flexbox/Flex");
exports.ButtonsContainer = styled_components_1.default.div `
    margin-top: ${Tokens.SIZES[1]};

    & > * {
        margin-top: ${Tokens.SIZES[1]};
    }
`;
/** Card Body */
// Doing this rather than a union type so that can iterate through in
//  the stories and show all the variants easily if we want to
const ActionCardBodyColourVariantsList = [
    "green",
    "yellow",
    "red",
    "blue",
    "purple",
    "white",
    "gray",
];
const { primary, greyscale } = Tokens.COLOURS;
const { soft, radius } = Tokens.BORDERS;
const CardColour = {
    red: {
        backgroundColor: primary.red["10"],
        border: soft.red,
    },
    green: {
        backgroundColor: primary.green["10"],
        border: soft.green,
    },
    blue: {
        backgroundColor: primary.blue["10"],
        border: soft.blue,
    },
    yellow: {
        backgroundColor: primary.yellow["10"],
        border: soft.yellow,
    },
    purple: {
        backgroundColor: primary.purple["10"],
        border: soft.purple,
    },
    white: {
        backgroundColor: greyscale.white,
        border: soft.silver,
    },
    gray: {
        backgroundColor: greyscale.cloud,
        border: soft.silver,
    },
};
exports.StyledColouredCard = styled_components_1.default.div `
    border-radius: ${radius};
    box-sizing: border-box;
    padding: ${Tokens.SIZES["2"]};
    ${({ colour }) => CardColour[colour]}
    margin-top: ${Tokens.SIZES["1"]};
`;
/** Content Type */
exports.StyledCard = styled_components_1.default.div `
    margin-top: ${Tokens.SIZES[2]};
`;
exports.StyledFlex = (0, styled_components_1.default)(Flex_1.Flex) `
    margin: -4px;
    align-items: center;
`;
//# sourceMappingURL=ActionCard.styles.js.map